import React from "react";

// Styled components
import styled from "styled-components";
import { About, Description, Image } from "../styles";

// Icons
import clock from "../img/codLang.png";
import diaphragm from "../img/copywriting.png";
import money from "../img/3d-modeling.png";
import teamwork from "../img/help.png";

// Images
import home2 from "../img/home1.png";

// Scroll animation - custom hook
import { fade } from "../animation";
import { useScroll } from "./useScroll";

const ServicesSection = () => {
  const [element, controls] = useScroll();

  return (
    <Services ref={element} variants={fade} animate={controls} initial="hidden">
      <Description>
        <h2>
          What <span>I Can</span> Do For <span>You</span> ?
        </h2>
        <Cards>
          <Card>
            <div className="icon">
              <img src={clock} alt="Clock" />
              <h3>Web-Dev</h3>
            </div>
            <p>Get Dynamic-Snappy Web landing page for your stratup</p>
          </Card>
          <Card>
            <div className="icon">
              <img src={teamwork} alt="Teamwork" />
              <h3>Coding-Query</h3>
            </div>
            <p>Stuck in your CS Project !?</p>
          </Card>
          <Card>
            <div className="icon">
              <img src={diaphragm} alt="Diaphram" />
              <h3>Content-Writing</h3>
            </div>
            <p>Have an Idea to present..Worry No more !</p>
          </Card>
          <Card>
            <div className="icon">
              <img src={money} alt="Money" />
              <h3>3D Designing</h3>
            </div>
            <p>I can make you 3D-Rendered Models for your Project</p>
          </Card>
        </Cards>
      </Description>
      <Image>
        <img src={home2} alt="Camera" />
      </Image>
    </Services>
  );
};

const Services = styled(About)`
  h2 {
    padding-bottom: 5rem;
  }

  p {
    width: 70%;
    padding: 2rem 0rem 4rem 0rem;
  }
`;

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 1300px) {
    justify-content: center;
  }
`;

const Card = styled.div`
  flex-basis: 20rem;
  .icon {
    display: flex;
    align-items: center;
    h3 {
      margin-left: 1rem;
      background: white;
      color: black;
      padding: 1rem;
    }
  }
`;

export default ServicesSection;
